import { render, staticRenderFns } from "./account-settings.page.vue?vue&type=template&id=442a0809&"
import script from "./account-settings.page.vue?vue&type=script&lang=ts&"
export * from "./account-settings.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports